<div class="input-icon mb-3" [ngClass]="{'bg-dark text-white':isDark}">
                              <span class="input-icon-addon">
                                <div class="spinner-border spinner-border-sm text-muted" role="status"></div>
                              </span>
  <input type="text" class="form-control" placeholder="Lütfen Bekleyiniz…" [readOnly]="true">
</div>
